import React,{useState, useEffect} from 'react';
import axios from 'axios';
import axiosUrl from '../../../axios/url';
import PropTypes from 'prop-types';

export default function TagAddModal(param) {

    const [representiveName, setRepresentiveName] = useState("");

    async function postRepresentiveCreate(){
        // if(representiveName === ''){ alert('대표태그 명을 입력하세요.'); return;}

        // if(!window.confirm('대표태그를 저장하시겠습니까?')) return;
        var sendData = {
            name: representiveName
        }
        await axios.post(axiosUrl.representives_create+"/"+param.projectId+"/representives", sendData)
        .then( response => {
            console.log("representive create success");
            // alert('대표태그가 추가되었습니다.');
            param.callbackRepresentiveClose();
            document.getElementById('close').click();

        })
        .catch(function (e) {
            alert('대표태그가 등록에 실패하였습니다. 다시 시도하세요.');
                console.error('[MEDIEX_CMS_2019_ERROR] postRepresentiveCreate - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.project_list);
        });

    }

    useEffect(() => {
        setRepresentiveName("");
    },[param])

    function representivesSave() {
        postRepresentiveCreate();
    }

    function changeRepresentiveName(e) {
        setRepresentiveName(e.target.value);
    }

    return(
        <div className="modal fade" id="tagAddModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    
                    <div className="modal-header">
                        <h4 className="modal-title">대표태그 추가</h4>
                        <button id="close" type="button" className="close" data-dismiss="modal">&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <input className="form-control"  placeholder="대표태그명" value={representiveName} onChange={(e) => changeRepresentiveName(e)}/>
                    </div>
                    
                    <div className="modal-footer">
                        <button type="button"  className="btn btn-secondary" data-dismiss="modal">닫기</button>
                        <button type="button"  className="btn btn-primary" onClick={representivesSave} >저장</button>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

TagAddModal.propTypes = {
    projectId: PropTypes.string,
    callbackRepresentiveClose: PropTypes.any
};